import {BUILD_VERSION} from './buildInfo.js'
import {hardReloadApp} from './forceRefresh.js'
import {logRuntimeEvent} from './telemetry.js'

let controllerReloading = false

function shouldRegisterServiceWorker() {
  if (typeof window === 'undefined') return false
  if (!('serviceWorker' in navigator)) return false
  if (import.meta.env.DEV) return false
  return window.isSecureContext || ['localhost', '127.0.0.1'].includes(window.location.hostname)
}

function reloadOnControllerChange() {
  if (controllerReloading || typeof window === 'undefined') return
  controllerReloading = true
  logRuntimeEvent('service_worker_controller_changed', {
    buildVersion: BUILD_VERSION,
  }, {flush: false})
  void hardReloadApp({reason: 'service-worker-controllerchange'})
}

export async function registerAppServiceWorker() {
  if (!shouldRegisterServiceWorker()) {
    return null
  }

  try {
    const registration = await navigator.serviceWorker.register('/service-worker.js', {
      scope: '/',
      updateViaCache: 'none'
    })

    logRuntimeEvent('service_worker_registered', {
      buildVersion: BUILD_VERSION,
      activeState: registration.active?.state || null
    })

    void registration.update()

    navigator.serviceWorker.addEventListener('controllerchange', reloadOnControllerChange)

    if (registration.waiting) {
      registration.waiting.postMessage({type: 'SKIP_WAITING'})
    }

    registration.addEventListener('updatefound', () => {
      const installing = registration.installing
      if (!installing) return

      installing.addEventListener('statechange', () => {
        logRuntimeEvent('service_worker_state_changed', {
          buildVersion: BUILD_VERSION,
          state: installing.state
        }, {flush: false})

        if (installing.state === 'installed' && navigator.serviceWorker.controller) {
          installing.postMessage({type: 'SKIP_WAITING'})
        }
      })
    })

    return registration
  } catch (error) {
    logRuntimeEvent('service_worker_registration_failed', {
      buildVersion: BUILD_VERSION,
      message: error?.message || 'Registration failed'
    })
    return null
  }
}
